<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.assistante',1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <div class="row">

                        <b-container>

                            <b-row>
                                <b-col col sm="8">
                                    <div class="list-group">
                                        <b-row>
                                            <b-col col sm="12" class="mb-3">
                                                <div class="">
                                                    <h4 class="consultation-item__title"> {{ $t('message.nomPartenaire') }} </h4>
                                                    <span class="font-weight-bold">
                                                    <p class="consultation-item__body"> {{ nom }} </p>
                                                </span>
                                                </div>
                                            </b-col>

                                            <b-col col sm="12" class="mb-3">
                                                <div class="">
                                                    <h4 class="consultation-item__title"> {{ $t('message.email') }} </h4>
                                                    <span class="font-weight-bold">
                                                    <p class="consultation-item__body"> {{ email }} </p>
                                                </span>
                                                </div>
                                            </b-col>

                                            <b-col col sm="12" class="mb-3">
                                                <div class="">
                                                    <h4 class="consultation-item__title"> {{ $t('message.phoneNumber') }} </h4>
                                                    <span class="font-weight-bold">
                                                    <p class="consultation-item__body"> {{ telephone }} </p>
                                                </span>
                                                </div>
                                            </b-col>

                                            <b-col col sm="12" class="mb-3">
                                                <div class="">
                                                    <h4 class="consultation-item__title"> {{ $t('message.institution') }} </h4>
                                                    <span class="font-weight-bold">
                                                    <p class="consultation-item__body"> {{ etablissement }} </p>
                                                </span>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </b-col>
                                <b-col col sm="4">
                                    <b-row class="justify-content-sm-center">
                                        <b-button variant="primary" @click="updateAssistante">
                                            {{ $t('message.edit') }}
                                        </b-button>

                                        <b-button variant="danger" v-b-modal.delete-modal>
                                            {{ $t('message.delete') }}
                                        </b-button>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $t('message.categoriePrestation')"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ nom }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteAssistante">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";

    export default {
        name: "Assistant",
        computed: {
            ...mapGetters(["assistante",'hasAdminRole',
                'hasGestionnaireRole','hasMedecinControleRole','hasAssistante']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.hasAssistante;
            },

            mAssistante: function() {

                return this.assistante;
                
            },

            nom:function(){
                if (!_.isUndefined(this.assistante.user) && !_.isNull(this.assistante.user)) {
                    let user = this.assistante.user;
                    let prenom = (user.prenom == null) ? '' : user.prenom;
                    return (user.nom).toUpperCase() + " " +prenom.charAt(0).toUpperCase() + prenom.substring(1);
                }
                return '';
            },
           
            etablissement:function(){
                if (!_.isUndefined(this.assistante.etablissements)){
                   return this.assistante.etablissements.name;
                }
                
            },

            email:function(){
                if (!_.isUndefined(this.assistante.user)){
                    return this.assistante.user.email;
                }
                return '';
            },

            telephone:function(){
                if (!_.isUndefined(this.assistante.user)){
                    return this.assistante.user.telephone;
                }
                return '';
                
            },
            
        },

        data() {
            return {
                assistante_id: this.$route.params.assistant,
            }
        },

        methods: {
            getAssistante() {
                let args = {
                    assistante: this.assistante_id,
                };
                this.$store.dispatch("getAssistante", {args});
            },

            onPrestationClick(params) {
                this.$router.push({ name: 'prestation', params: { prestation: params.row.slug } });

            },
            deleteAssistante() {
                let args = {
                    assistante: this.assistante_id,
                };

                let successMessage = this.$i18n.t('message.assitanteDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteAssistante', {args, successMessage, errorMessages})
            },
            updateAssistante:function () {
                this.$router.push({ name: 'edit-assistant', params: { assistant: this.assistante_id } });

            }
        },
        mounted() {
            this.getAssistante();
        }
    }
</script>

<style scoped>

</style>